import { render, staticRenderFns } from "./TicketsSettingsView.vue?vue&type=template&id=0e54fef4&lang=pug&"
import script from "./TicketsSettingsView.vue?vue&type=script&lang=js&"
export * from "./TicketsSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports